/*************************************
 *
 * 直播路由管理
 *
 *************************************/

const live = [
  {
    path: '/live/list',
    name: 'LiveList',
    component: () => import('@/views/live/liveList/index'),
    meta: {
      title: '壹品仓直播',
      keepAlive: true,
      auth: true,
      isWechat: true
    }
  },
  {
    path: '/live/play',
    name: 'LivePlay',
    component: () => import('@/views/live/livePlay/index'),
    meta: {
      title: '直播中',
      keepAlive: false,
      auth: true,
      isWechat: true
    }
  }
]

export default live



// WEBPACK FOOTER //
// ./src/router/modules/live.js